import { useState } from "react";
import { AppBar, ResourceContextProvider, TitlePortal } from "react-admin";
import CustomUserMenu from "../userMenus/CustomUserMenu";
import ChangePassword from "../changePasswords/ChangePassword";
import { ThemeSwapper } from "../themeSwapper/ThemeSwapper";
import CompanySwapper from "../companySwapper/CompanySwapper";
import NavbarMenu from "../navBarMenus/NavbarMenu";

const MyAppBar = () => {
  const [openAdd, setOpen] = useState(false);

  return (
    <AppBar 
      userMenu={<CustomUserMenu setOpen={setOpen} />}
      sx={{
        // ✅ Hilangkan tombol hamburger
        '& .RaAppBar-menuButton': {
          display: 'none !important',
        },
      }}>
      <TitlePortal />
      <NavbarMenu />
      <ThemeSwapper />
      <CompanySwapper />
      <ResourceContextProvider value="change-passwords">
        <ChangePassword open={openAdd} setOpen={setOpen} />
      </ResourceContextProvider>
    </AppBar>
  );
};
export default MyAppBar;
